// src/components/store/sections/testimonials/TestimonialV93CardsliderSlateGold.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV93CardsliderSlateGold(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={93}
      archKey="card_slider"
      archLabel="Review Card Carousel"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      hexCol="#eab308"
      {...props}
    />
  );
}
